export default "__VITE_ASSET__08cd4143__"